module.exports = __webpack_public_path__ + "img/13-green.dc2e017e.svg";